<template>
  <div class="main">
    <v-container class="pa-0 d-flex justify-center">
      <div class="top-section">
        <header class="navbar">
          <v-img
              :src="require('../assets/montezuma.svg')"
              width="150px"
              height="60px"
              alt="Montezuma Logo"
          />
          <v-spacer/>

          <nav class="d-flex">
            <ul
                class="nav-links"
                :class="{ open: mobileMenuOpen }"
            >
              <li>
                <a href="#how-it-works" @click="closeMobileMenu">
                  {{ $t(translation + '.navigation.how_it_works') }}
                </a>
              </li>
              <li>
                <a href="#application" @click="closeMobileMenu">
                  {{ $t(translation + '.navigation.application') }}
                </a>
              </li>
              <li>
                <a href="#faq-section" @click="closeMobileMenu">
                  {{ $t(translation + '.navigation.faq') }}
                </a>
              </li>
              <li>
                <a href="#contact" @click="closeMobileMenu">
                  {{ $t(translation + '.navigation.contact') }}
                </a>
              </li>
            </ul>
            <div
                class="hamburger"
                @click="toggleMobileMenu"
                role="button"
                aria-label="Toggle navigation menu"
                :aria-expanded="mobileMenuOpen.toString()"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </nav>
        </header>
        <section class="hero-section">
          <hr class="gradient-line">
          <v-row
              class="hero-content"
              align="center"
              justify="space-between"
              no-gutters
          >
            <v-col
                cols="12"
                md="6"
                class="text-md-left text-center"
            >
              <h1 class="hero-section-text1 mb-3">
                {{ $t(translation + '.hero-section.text-1') }}
              </h1>
              <h2 class="hero-section-text2 mb-4">
                {{ $t(translation + '.hero-section.text-2') }}
              </h2>
              <p class="hero-section-caption-text mb-6">
                {{ $t(translation + '.hero-section.caption') }}
              </p>

              <v-row
                  justify="center"
                  justify-md="start"
                  class="download-row"
                  no-gutters
              >
                <v-col
                    cols="12"
                    sm="4"
                    class="d-flex justify-center mb-8 mb-sm-0"
                >
                  <div class="download-box">
                    <img
                        :src="require('../assets/landing/qr/android.png')"
                        alt="QR Android"
                        class="qr-place"
                    />
                    <img
                        :src="require('../assets/landing/icons/android-store_1.svg')"
                        class="store-img"
                        alt="Download on Android"
                    />
                  </div>
                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    class="d-flex justify-center mb-8 mb-sm-0"
                >
                  <div class="download-box">
                    <img
                        :src="require('../assets/landing/qr/apple.png')"
                        alt="QR Apple"
                        class="qr-place"
                    />
                    <img
                        :src="require('../assets/landing/icons/apple-store_1.svg')"
                        class="store-img"
                        alt="Download on Apple"
                    />
                  </div>
                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    class="d-flex justify-center"
                >
                  <div class="download-box">
                    <img
                        :src="require('../assets/landing/qr/huawei.png')"
                        alt="QR Huawei"
                        class="qr-place"
                    />
                    <img
                        :src="require('../assets/landing/icons/huawei-store_1.svg')"
                        class="store-img"
                        alt="Download on Huawei"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col
                cols="12"
                md="6"
                class="d-flex justify-center"
            >
              <v-img
                  :src="require('../assets/landing/hero-image.png')"
                  max-width="100%"
                  class="hero-image"
                  contain
                  alt="Montezuma hero image"
              />
            </v-col>
          </v-row>
          <hr class="gradient-line mb-10">

          <h1 class="popular-text">{{ $t(translation + '.popular-section.title') }}</h1>

          <v-row
              wrap
              justify="center"
              class="category-row mb-10"
          >
            <v-col
                v-for="(icon, index) in icons"
                :key="index"
                cols="6"
                sm="4"
                md="2"
                class="d-flex flex-column justify-start align-center mb-6"
            >
              <div class="icon-box">
                <v-img
                    :src="require(`../assets/landing/icons/` + icon.icon)"
                    class="icon-img"
                    contain
                />
              </div>
              <h3 class="mt-3 text-center white--text font-weight-bold text-uppercase">{{ icon.title }}</h3>
            </v-col>
          </v-row>
        </section>
      </div>
    </v-container>
    <div class="w-100 d-flex justify-center" style="background-color: white;">
      <section
          id="how-it-works"
          class="functionality-section pt-12"
      >
        <h1 class="functionality-title mb-4">
          {{ $t(translation + '.functionality-section.title') }}?
        </h1>

        <v-row
            class="ma-0 pa-0 w-100"
        >
          <v-col cols="12" md="7" class="d-flex align-center ma-0 pa-0 w-100">
            <v-row class="ma-0 pa-0 w-100">
              <v-col
                  v-for="(step, index) in steps"
                  :key="index"
                  cols="12"
                  sm="6"
                  md="6"
                  xl="4"
                  class="step-col"
              >
                <v-img
                    :src="require(`../assets/landing/icons/${step.icon}`)"
                    class="step-img mb-8"
                    contain
                />
                <h3 class="step-title">{{ step.title }}</h3>
                <p class="step-description">
                  {{ step.description }}
                </p>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="5" class="d-flex justify-center align-center">
            <v-img
                :src="require('../assets/landing/funcionality-section.png')"
                max-width="100%"
                max-height="600px"
                contain
                class="functionality-image-overlap"
            />
          </v-col>
        </v-row>

      </section>
    </div>
    <div class="w-100 d-flex justify-center" style="background-color: rgba(21, 21, 33, 0.89);">
      <section id="application" class="mobile-section py-12 -test">
        <v-row class="d-flex flex-wrap " style="width: 100%; margin: 0; padding: 0">
          <!-- List Column (1/3 width) -->
          <v-col cols="12" md="4" class="d-flex align-center justify-center justify-lg-start " style="width: 100%">
            <ul class="custom-list justify-center " style="padding-left: 0; margin-left: 0;">
              <li class="d-flex align-center mb-6" style="padding-left: 0;">
                <v-img
                    :src="require('../assets/landing/icons/check-mark.svg')"
                    alt="icon"
                    contain
                    class="list-icon"
                    width="20"
                    height="20"
                />
                <h3 style="margin: 0;">{{ $t(translation + '.mobile-section.easy-search') }}</h3>
              </li>
              <li class="d-flex align-center mb-6" style="padding-left: 0;">
                <v-img
                    :src="require('../assets/landing/icons/check-mark.svg')"
                    alt="icon"
                    contain
                    class="list-icon"
                    width="20"
                    height="20"
                />
                <h3 style="margin: 0;">{{ $t(translation + '.mobile-section.verified-contractors') }}</h3>
              </li>
              <li class="d-flex align-center mb-6" style="padding-left: 0;">
                <v-img
                    :src="require('../assets/landing/icons/check-mark.svg')"
                    alt="icon"
                    contain
                    class="list-icon"
                    width="20"
                    height="20"
                />
                <h3 style="margin: 0;">{{ $t(translation + '.mobile-section.user-reviews') }}</h3>
              </li>
              <li class="d-flex align-center" style="padding-left: 0;">
                <v-img
                    :src="require('../assets/landing/icons/check-mark.svg')"
                    alt="icon"
                    contain
                    class="list-icon"
                    width="20"
                    height="20"
                />
                <h3 style="margin: 0;">{{ $t(translation + '.mobile-section.free-account') }}</h3>
              </li>
            </ul>
          </v-col>


          <!-- Image Column (2/3 width) -->
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" sm="4">
                <v-img :src="require('../assets/landing/SS-01.png')" contain class="responsive-img"/>
              </v-col>
              <v-col cols="12" sm="4">
                <v-img :src="require('../assets/landing/SS-02.png')" contain class="responsive-img"/>
              </v-col>
              <v-col cols="12" sm="4">
                <v-img :src="require('../assets/landing/SS-03.png')" contain class="responsive-img"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </div>
    <div class="w-100 d-flex justify-center" style=" background-color: #2B2B41;">
      <section id="faq-section" class="faq-section py-10">
        <v-row class="w-100">
          <v-col
              class="d-flex flex-column align-center align-lg-start justify-center text-center text-lg-left mr-lg-8 mx-sm-4 px-sm-4"
          >
            <h2 class="faq-title mb-4">{{ $t(translation + '.faq-section.title') }}</h2>
            <v-btn
                @click="faqPanels = !faqPanels"
                class="white--text"
                style="font-weight: 800"
                color="#BE1E2D"
                rounded
            >
              {{ faqPanels ? $t(translation + '.faq-section.hide') : $t(translation + '.faq-section.show') }}
            </v-btn>
          </v-col>

          <v-col class="d-flex align-center justify-center justify-lg-start ml-lg-8">
            <v-img
                :src="require('../assets/landing/faq_image.png')"
                contain
                class="mb-5"
                style="max-width: 250px; height: auto;"
            />
          </v-col>
        </v-row>

        <v-expansion-panels multiple v-if="faqPanels" class="mt-10">
          <v-expansion-panel
              v-for="(question, index) in questions"
              :key="index"
          >
            <v-expansion-panel-header>{{ question.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ question.answer }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </section>
    </div>
    <div class="footer-wrapper">
      <v-footer id="contact" class="footer " padless>
        <v-col class="d-flex justify-center " cols="12">
          <v-img
              :src="require('../assets/landing/montezuma_white.svg')"
              contain
              class="footer-logo mb-5"
          />
        </v-col>
        <v-row
            align="center"
            justify="space-between"
            class="footer-row "
            no-gutters
        >
          <!-- Logo -->
          <v-col
              cols="12"
              sm="3"
              class="footer-contact "
          >
            <a :href="`mailto:${email}`" class="contact-link">{{ email }}</a>
          </v-col>

          <!-- Contact Info -->
          <v-col
              cols="12"
              sm="3"
              class="footer-contact"
          >
            <a :href="`tel:${phone}`" class="contact-link">{{ phone }}</a>
          </v-col>

          <!-- Social Icons -->
          <v-col
              cols="12"
              sm="3"
              class="footer-social "
          >
            <a href="https://www.facebook.com" target="_blank" rel="noopener">
            <v-img
                :src="require('../assets/landing/icons/facebook.svg')"
                contain
                class="social-icon "
            />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener">
            <v-img
                :src="require('../assets/landing/icons/instagram.svg')"
                contain
                class="social-icon"
            />
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener">
            <v-img
                :src="require('../assets/landing/icons/linkedin.svg')"
                contain
                class="social-icon"
            />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener">
            <v-img
                :src="require('../assets/landing/icons/youtube.svg')"
                contain
                class="social-icon"
            />
            </a>
          </v-col>
        </v-row>
      </v-footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandingView",
  data() {
    return {
      translation: "landing_page",
      mobileMenuOpen: false,
      icons: [
        {icon: 'Asset 3.svg', title: "Baštovanske usluge"},
        {icon: 'it.svg', title: "IT usluge"},
        {icon: 'transport_selidbe.svg', title: "Transport i selidbe"},
        {icon: 'zdrastvo_njega.svg', title: "Zdrastvo i njega"},
        {icon: 'popravka_montaza.svg', title: "Popravka i montaža"},
        {icon: 'Asset 6.svg', title: "Dostava"},
      ],
      steps: [
        {
          icon: 'icon-magnifying-glass.svg',
          title: 'Potraži ponudu',
          description: 'Istraži širok spektar usluga i pronađi izvođača koji ispunjava tvoje zahtjeve.'
        },
        {
          icon: 'paper-plane-icon.svg',
          title: 'Pošalji zahtjev',
          description: 'Kontaktiraj izvođače brzo i jednostavno direktno putem aplikacije.'
        },
        {
          icon: 'trophy-icon.svg',
          title: 'Ostavi recenziju',
          description: 'Podijeli svoje iskustvo i pomozi drugima u izboru pravog izvođača.'
        }
      ],
      faqPanels: false,
      questions: [
        {
          question: "Kako mogu kreirati nalog?",
          answer: "Kreiranje naloga je potpuno besplatno. Kliknite na “Registracija” i pratite jednostavne korake."
        }, {
          question: "Da li su svi izvođači provjereni?",
          answer: "Da, svaki izvođač prolazi proces verifikacije prije nego što se pojavi na platformi."
        }, {
          question: "Kako mogu ostaviti recenziju?",
          answer: "Nakon završene saradnje sa izvođačem, dobićete opciju da ostavite recenziju direktno putem platforme."
        }, {
          question: "Da li mogu koristiti platformu besplatno?",
          answer: "Da, korištenje platforme je besplatno za sve korisnike."
        }
      ],
      email: "info@montezuma.me",
      phone: "+382 69 123 123"
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@400;500;700&display=swap');

html {
  scroll-behavior: smooth;
}

.w-100 {
  width: 100%;
}
.main {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #2B2B41;
  font-family: 'Catamaran', sans-serif;
}

.top-section {
  max-width: 1200px;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: #2B2B41;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2B2B41;
  color: white;

}

/* Navigation links */
.nav-links {
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  list-style: none;
  display: flex;
  gap: 24px;
  margin: 0;
  padding: 0;
}

.nav-links li a {
  text-decoration: none;
  color: white;
  font-weight: 800;
  transition: color 0.3s;
}

.nav-links li a:hover {
  color: #FF69B4;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background-color: white;
  border-radius: 2px;
}

/* Mobile styles */
@media (max-width: 768px) {
  .nav-links {
    position: absolute;
    top: 80px;
    right: 0;
    background-color: #2B2B41;
    flex-direction: column;
    align-items: flex-start;
    max-height: 0;
    overflow: hidden;
    padding-top: 10px;
    width: 100%;
    transition: max-height 0.3s ease-in-out;
    z-index: 1000;
    text-align: center;
    display: flex;
  }

  .nav-links.open {
    max-height: 1000px;
  }

  .nav-links li {
    width: 100%;
  }

  .nav-links li:first-child {
    border-top: 3px solid rgba(255, 255, 255, 0.1);

  }

  .nav-links li a {
    width: 100%;
    font-size: 1.2rem;
    font-weight: 700;
    color: white;
    text-decoration: none;
    display: block;
    padding: 20px 0;
    border-bottom: 3px solid rgba(255, 255, 255, 0.1);
  }

  .nav-links li a:hover {
    color: #FF69B4;
  }

  .hamburger {
    display: flex;
  }
}

.gradient-line {
  border: none;
  height: 2px;
  background: linear-gradient(to right, rgba(255, 105, 180, 0), rgba(255, 105, 180, 1), rgba(255, 105, 180, 0));
}

.hero-section {
  background-color: #2b2b41;
  padding: 5px 20px;
}

.hero-content {
  margin-top: 5px;
}

.hero-section-text1 {
  color: #ffffff;
  font-weight: 800;
  font-size: 2rem;

  @media (min-width: 960px) {
    font-size: 2.5rem;
  }
}

.hero-section-text2 {
  color: #ffffff;
  font-weight: 500;
  font-size: 1.5rem;

  @media (min-width: 960px) {
    font-size: 2rem;
  }
}

.hero-section-caption-text {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 400;
}

.download-box {
  background-color: white;
  border-radius: 15px;
  width: 150px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.store-img {
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  width: 120%;
  height: auto;
}

.qr-placeholder {
  font-size: 0.9rem;
  margin-bottom: 30px;
  color: #333;
}

.qr-place {
  width: 100%;
  height: 100%;
  padding-bottom: 30px;
}

.hero-image {
  width: 100%;
  height: auto;
  max-height: 500px;
}

.popular-text {
  color: #ffffff;
  text-align: center;
  font-size: 2rem;
  letter-spacing: 1px;
  position: relative;
  padding-bottom: 10px;
  text-transform: uppercase;
  font-weight: 800;
}

.category-row {
  margin-top: 20px;
}

.icon-box {
  width: 100px;
  height: 100px;
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);

}

.icon-img {
  width: 60px;
  height: 60px;
}

.functionality-section {
  max-width: 1200px;
  width: 100%;
  padding: 0;
  margin: 0;
}

.functionality-title {
  color: #2B2B41;
  font-size: 2.2rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative; /* Needed for the pseudo-element to position itself */
  display: inline-block; /* Keeps the gradient tight under the text */
}

.functionality-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px; /* adjust to create spacing between text and line */
  width: 100%;
  height: 3px; /* thickness of the gradient underline */
  background: linear-gradient(
      to right,
      rgba(255, 105, 180, 0),
      rgba(255, 105, 180, 1),
      rgba(255, 105, 180, 0)
  );
  border-radius: 2px; /* optional for smoother edges */
}

.step-title {
  color: #333333;
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 8px;
}

.step-description {
  color: #333333;
  font-size: 1rem;
  margin: 0 auto;
  font-weight: 400;
}

.functionality-image-overlap {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;

  @media (min-width: 1920px) {
    top: -120px;
  }
}

.mobile-section {
  max-width: 1200px;
  width: 100%;
  padding: 0;
  margin: 0;
}

.custom-list {
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}

.custom-list h3 {
  color: white;
  font-weight: 600;
}

.list-icon {
  flex: 0 0 auto; /* Prevents flex-grow */
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* Optional: Improve image responsiveness */
.responsive-img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.faq-section {
  max-width: 1200px;
  width: 100%;
  padding: 0;
  margin: 0;
}

.faq-section h2 {
  font-weight: 800;
  text-transform: uppercase;
  color: white;
}

.footer-wrapper {
  width: 100%;
  background-color: #BE1E2D;
  display: flex;
  justify-content: center;
  padding: 1.5rem 0;
}

.footer {
  width: 100%;
  max-width: 1200px;
  color: white;
  background-color: #BE1E2D !important;
}


.footer-logo {
  max-width: 230px;
  height: auto;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1rem;
  gap: 0.5rem;
  text-align: center;
}

.contact-item {
  white-space: nowrap;
  color: white;
  font-weight: 700;
}

.footer-social {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.social-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.social-icon:hover {
  transform: scale(1.2);
}

.step-img {
  width: 130px;
  height: 130px;
}


/* Responsive tweaks */
@media (max-width: 600px) {
  .functionality-title {
    display: block;
    margin: 0 auto;
    text-align: center;
  }

  .step-img {
    width: 90px;   /* smaller width for mobile */
    height: 90px;
  }

  .step-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .footer-contact {
    margin-top: 1rem;
    text-align: center;
  }

  .footer-social {
    justify-content: center;
    margin-top: 1rem;
  }
}

.contact-link {
  color: inherit;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}

.border-test {
  border: 1px solid red;
}
</style>